import { render } from "./index.vue?vue&type=template&id=78fa6bfa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=78fa6bfa&lang=less&scoped=true"

import exportComponent from "D:\\rwkj\\suershouyyph-mobile\\保安端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fa6bfa"]])

export default __exports__